// conditionally add properties to an object or elements to an array
// pass in an object or an array
// spread the result
const maybe = (what, when) => (when && what) || []

export default maybe



// WEBPACK FOOTER //
// ./src/utilities/maybe.js